import { Component, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { CalendarEvent, CalendarEventAction } from 'angular-calendar';
import { isSameDay, isSameMonth, startOfDay, endOfDay } from 'date-fns';

import { AddCalendarEventComponent } from './add.calendar.event.component';
import { CalendarEventService } from '../services/calendar.event.service';

@Component({
  selector: 'tv-calendar',
  templateUrl: './calendar.component.html'
})
export class CalendarComponent {
  public currentView: string;
  viewDate: Date = new Date();
  activeDayIsOpen = false;
  eventHash: Map<string, CalendarEvent> = new Map<string, CalendarEvent>();
  @Output() viewDateChange: EventEmitter<Date> = new EventEmitter();
  refresh: Subject<any> = new Subject();
  modalData: {
    action: string;
    event: CalendarEvent;
  };

  get events(): CalendarEvent[] {
    return Array.from(this.eventHash.values());
  }

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fa fa-fw fa-times"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        // this.events = this.events.filter(iEvent => iEvent !== event);
        console.log('Action event', event);
        this.removeEvent(this.getKey(event.start));
      }
    }
  ];

  private colors: any = {
    red: {
      primary: '#ad2121',
      secondary: '#FAE3E3'
    }
  };

  constructor(public dialog: MatDialog, private calendarEventService: CalendarEventService) {
    this.viewDate = new Date();
    this.currentView = 'month';
    this.fetchEvents();
  }

  dayClicked({ date, events }: { date: Date; events: Array<CalendarEvent<any>>; }): void {
    console.log('Day and events', date, events);
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
      }

      const key = this.getKey(date);
      console.log('Key Hash', key, this.eventHash);
      if (this.eventHash.has(key) === false) {
        this.openAddEvent(key);
      }
    }
  }

  private openAddEvent(key: string): void {
    const dialogRef = this.dialog.open(AddCalendarEventComponent, {
      data: { eventDescription: 'Holiday' }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.addEvent(key, result);
      }
    });
  }

  private removeEvent(key: string): void {
    this.eventHash.delete(key);
    this.refresh.next();
  }

  private addEvent(key: string, title: string): void {
    const date = new Date(key);
    this.eventHash.set(key, this.createEvent(date, title));
    this.refresh.next();
  }

  private createEvent(date: Date, title: string): any {
    return {
      title: title,
      start: startOfDay(date),
      end: endOfDay(date),
      color: this.colors.red,
      actions: this.actions
    };
  }

  private fetchEvents(): void {
    this.calendarEventService.getCalendarEvents(1, this.viewDate).subscribe(data => {
      console.log('Data for get events is ', data);
      this.eventHash.clear();
      for (const calendarEvent of data) {
        const key = this.getKey(calendarEvent.eventDate);
        this.eventHash.set(key, this.createEvent(calendarEvent.eventDate, calendarEvent.eventName));
      }
    },
      err => console.log('Get events failed', err));
  }

  private getKey(date: Date): string {
    return startOfDay(date).toDateString();
  }
}
